import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from 'react';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { AclNotification } from 'entities/device.acl.suggestion/ui/notification';
export const AclSuggestions = memo(function AclNotifications() {
    const incoming_suggestions = useAppSelector((state) => state.access_suggestions.in);
    if (incoming_suggestions.length === 0) {
        return null;
    }
    return (_jsx(_Fragment, { children: incoming_suggestions.slice(0, 3).map((suggestion, i) => (_jsx(AclNotification, { suggestion: suggestion }, i))) }));
});
